<div class="row" *ngIf="!Selected?.standby && Selected?.id ">
  <div class="col-lg-12 d-flex align-items-center" >
    <span class="badge font-20">
      Spedizione N: {{Selected?.progressivo}} ( {{Selected.data_inizio_prevista | date: 'dd/MM/yyyy'}} ) - RIEPILOGO DATI
    </span>
    <label class="container" style="margin-left: 10px; width: auto; margin-right: 10px;" *ngIf="!preventivo">
      <input type="checkbox"  [(ngModel)]="Selected.standby" >
      <span class="checkmark"></span>
      ATTENDERE
    </label>
    <label class="container" style="margin-left: 10px; width: auto; margin-right: 10px; ">
      <input type="checkbox" [(ngModel)]="Selected.pratica" >
      <span class="checkmark"></span>
      PRATICA
    </label>
    <label class="container" *ngIf="Selected?.ldv?.length>0" style="margin-left: 0; width: auto; margin-right: auto; padding: 0 ">
      <button (click)='Tracking(Selected)' style="margin-left: 0; width: auto; margin-right: 0; "  type="button" class="btn btn-ciano">
        <i class="fas fa-box-open " style=" font-size: 1.8em; color: #3dade6;"></i>
      </button>
      VAI AL TRACKING
    </label>

  </div>
  <div class="col-lg-3">
    <div class="card">
      <div class="card-body" >
        <h5 class="card-title" style="margin-left: 10pt">
          <img alt="Aggiungi" style="position: absolute;" height="44" width="39" src="assets/images/icon/Mittente@4x.png"/>
          &nbsp;
          <span style="margin-left: 27pt;">
            MITTENTE
          </span>
          &nbsp;
        </h5>
        <div class="d-flex align-items-center" style="margin-left: 40pt;">
          <span class="badge-text">
            {{Selected.mittente.nome}}
          </span>
        </div> <!-- nome -->
        <div class="d-flex align-items-center">
           <span class="badge-text">
            {{Selected.mittente.indirizzo}}
          </span>
        </div> <!-- indirizzo -->
        <div class="d-flex align-items-center">
          <span class="badge-text-mid" style="margin-right: 0.3em; width: unset">
            {{Selected.mittente.cap}}
          </span>
           <span class="badge-text-mid" style="width: -webkit-fill-available">
            {{Selected.mittente.citta}}
          </span>

        </div> <!-- citta -->
        <div class="d-flex align-items-center" >

          <span class="badge-text-mid" style="margin-left: auto; width: unset">
            {{Selected.mittente.provincia}}
          </span>
          <span class="badge-text-mid" style="margin-left: 1rem; width: unset">
            {{Selected.mittente.nazione?.length ? Selected.mittente.nazione[0].label : ''}}
          </span>

        </div> <!-- cap provincia tel-->
        <div class="d-flex align-items-center" style="margin-top: 0.2rem; " >
          <span class="badge-text-mid" style="margin-left: 0em; width: -webkit-fill-available; ">
            <i class="fas fa-phone" style="color: #53c954" ></i> &nbsp; {{Selected.mittente.tel}}
          </span>
        </div> <!-- cap provincia tel-->
<!--        <div class="d-flex align-items-center">-->
<!--          <span class="badge-text">-->
<!--            {{Selected.mittente.tel}}-->
<!--          </span>-->
<!--        </div> &lt;!&ndash; telefono &ndash;&gt;-->
        <div class="d-flex align-items-center">
          <span class="badge-text">
            {{Selected.mittente.cf}}
          </span>
        </div> <!-- cf -->

      </div>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="card">
      <div class="card-body" style="background-color: #3baf4a20;">
        <h5 class="card-title">
          <img alt="Aggiungi" style="position: absolute;" height="40" width="31" src="assets/images/icon/Destinatario@4x.png"/>
          &nbsp;
          <span style="margin-left: 27pt;">
            DESTINATARIO
          </span>
          &nbsp;
        </h5>
        <div class="d-flex align-items-center" style="margin-left: 30pt">
          <span class="badge-text">
            {{Selected.destinatario.nome}}
          </span>
        </div> <!-- nome -->
        <div class="d-flex align-items-center">
           <span class="badge-text">
            {{Selected.destinatario.indirizzo}}
          </span>
        </div> <!-- indirizzo -->
        <div class="d-flex align-items-center">
          <span class="badge-text-mid" style="margin-right: 0.3em; width: unset">
            {{Selected.destinatario.cap}}
          </span>
          <span class="badge-text-mid" style="width: -webkit-fill-available">
            {{Selected.destinatario.citta}}
          </span>

        </div> <!-- citta -->
        <div class="d-flex align-items-center" >

          <span class="badge-text-mid" style="margin-left: auto; width: unset">
            {{Selected.destinatario.provincia}}
          </span>
          <span class="badge-text-mid" style="margin-left: 1rem; width: unset">
            {{Selected.destinatario.nazione?.length ? Selected.destinatario.nazione[0].label : ''}}
          </span>
        </div> <!-- cap provincia tel-->
        <div class="d-flex align-items-center" style="margin-top: 0.2rem; " >
           <span class="badge-text-mid" style="margin-left: 0em; width: -webkit-fill-available; ">
              <i class="fas fa-email" style="color: #53c954" ></i> &nbsp; {{Selected.destinatario.email}}
            </span>

        </div> <!-- cap provincia tel-->
        <div class="d-flex align-items-center" style="margin-top: 0.2rem; " >

          <span class="badge-text-mid" style="margin-left: 0em; width: -webkit-fill-available; ">
            <i class="fas fa-phone" style="color: #53c954" ></i> &nbsp; {{Selected.destinatario.tel}}
          </span>
        </div> <!-- cap provincia tel-->
        <!--        <div class="d-flex align-items-center">-->
        <!--          <span class="badge-text">-->
        <!--            {{Selected.mittente.tel}}-->
        <!--          </span>-->
        <!--        </div> &lt;!&ndash; telefono &ndash;&gt;-->
        <div class="d-flex align-items-center">
          <span class="badge-text">
            {{Selected.destinatario.cf}}
          </span>
        </div> <!-- cf -->

      </div>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="card">
      <div class="card-body colli" style="background-color: rgb(244,233,222);">
        <h5 class="card-title" style="text-align: start">
          <img alt="Aggiungi" height="40" width="50" src="assets/images/icon/Colli@4x.png"/>
          &nbsp;
          COLLI
          &nbsp;
        </h5>
        <div class="d-flex align-items-center">
          <label class="mb-0" >Colli:</label> &nbsp;
          <span class="mb-0  text-dark" style="font-family: Roboto; font-weight: normal;">{{Selected?.colli?.length}}</span>
        </div> <!-- colli -->
        <div class="d-flex align-items-center">
          <label class="mb-0" >Peso (Kg):</label> &nbsp;
          <span class="mb-0  text-dark" style="font-family: Roboto; font-weight: normal;">{{collival('kg')|number: "1.1-1"}}</span>
        </div> <!-- Peso -->
        <div class="d-flex align-items-center">
          <label class="mb-0" >Peso Volumetrico (Kg/m3)</label> &nbsp;
          <span class="mb-0  text-dark" style="font-family: Roboto; font-weight: normal;" >{{collival('pe')|number: "1.1-1"}}</span>
        </div> <!-- Volumetrico -->
        <div class="d-flex align-items-center">
          <label class="mb-0" >Peso Volumetrico 333 (Kg/m3)</label> &nbsp;
          <span class="mb-0  text-dark" style="font-family: Roboto; font-weight: normal;" >{{collival('pe333')|number: "1.1-1"}}</span>
        </div> <!-- Volumetrico -->
        <div class="d-flex align-items-center">
          <label class="mb-0" >Peso Tassabile (Kg)</label> &nbsp;
          <span class="mb-0  text-dark" style="font-family: Roboto; font-weight: normal;">{{collival('pt')|number: "1.1-1"}}</span>
        </div> <!-- Tassabile -->
        <hr>
        <ng-container *ngFor="let collo of Selected.colli; let i = index">
          <div class="d-flex align-items-center" >
            <label class="mb-0" >Collo {{i + 1}}</label> &nbsp;
            <span class="mb-0  text-dark" style="font-family: Roboto; font-weight: normal;">{{collo.h | number: "1.1-1"}}&nbsp;x&nbsp;{{collo.l | number: "1.1-1"}}&nbsp;x&nbsp;{{collo.p | number: "1.1-1"}}</span>
          </div> <!-- Peso -->
          <div class="d-flex align-items-center" >
            <label class="mb-0" style="padding-left: 2rem;" >Peso (Kg)</label> &nbsp;
            <span class="mb-0  text-dark" style="font-family: Roboto; font-weight: normal;">{{collo.kg | number: "1.1-1"}}</span>
          </div> <!-- Peso -->
<!--          <div class="d-flex align-items-center" >-->
<!--            <label class="mb-0" style="padding-left: 2rem;" >Peso Volumetrico</label> &nbsp;-->
<!--            <span class="mb-0  text-dark" style="font-family: Roboto; font-weight: normal;">{{collo.pe | number: "1.1-1"}}</span>-->
<!--          </div> &lt;!&ndash; Peso &ndash;&gt;-->
<!--          <div class="d-flex align-items-center" >-->
<!--            <label class="mb-0" style="padding-left: 2rem;" >Peso Volumetrico 333:</label> &nbsp;-->
<!--            <span class="mb-0  text-dark" style="font-family: Roboto; font-weight: normal;">{{collo.pe333 | number: "1.1-1"}}</span>-->
<!--          </div> &lt;!&ndash; Peso &ndash;&gt;-->
<!--          <div class="d-flex align-items-center" >-->
<!--            <label class="mb-0" style="padding-left: 2rem;" >Peso Tassabile:</label> &nbsp;-->
<!--            <span class="mb-0  text-dark" style="font-family: Roboto; font-weight: normal;">{{collo.pt | number: "1.1-1"}}</span>-->
<!--          </div> &lt;!&ndash; Peso &ndash;&gt;-->
        </ng-container>

      </div>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="card">
      <div class="card-body costi" style="background-color: #f5f5be;" >
        <h5 class="card-title">
          <img alt="Aggiungi" height="34" width="31" src="assets/images/icon/Costi@4x.png"/>
          &nbsp;
          COSTI
          &nbsp;
        </h5>
        <div class="row">
          <div class="col-lg-4">
            <div class="">
              <label class="mb-0 " >Costo Spedizione:</label>
              <span class="mb-0  text-dark" >{{Selected.costoSpedizione }} €</span>
            </div> <!-- costo spedizione -->
          </div>
          <div class="col-lg-4">
            <div class="">
              <label class="mb-0 " >Totale:</label>
              <span class="mb-0  text-dark" style="background-color: #3baf4a60; font-weight: bolder!important; font-size: 1.05rem;" >{{Totale()}} €</span>
            </div> <!-- Totale -->
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4">
            <div class="">
              <label class="mb-0 " >Contrassegno:</label>
              <span class="mb-0  text-dark" >{{Selected.costoContrassegno }} €</span>
            </div> <!-- Contrassegno -->
            <div class="">
              <label class="mb-0  " >Triangolazione:</label>
              <span class="mb-0  text-dark" >{{Selected.costoTriangolazione}} € </span>
            </div> <!-- Triangolazione -->
            <div class="">
              <label class="mb-0  " >T10:</label>
              <span class="mb-0  text-dark" >{{Selected.t10}} € </span>
            </div> <!-- T10 -->
            <div class="">
              <label class="mb-0  " >Deposito:</label>
              <span class="mb-0  text-dark" >{{Selected.costoDeposito}} € </span>
            </div> <!-- Deposito -->
            <div class="" *ngIf="Selected.costoContrassegno >0">
              <label class="mb-0  " >Cont. spett. cliente:</label>
              <span class="mb-0  text-dark" >{{Selected.dareCliente}} € </span>
            </div> <!-- Deposito -->
          </div>

          <div class="col-lg-4">
            <div class="">
              <label class="mb-0" >Assicurazione:</label>
              <span class="mb-0  text-dark" >{{Selected.costoAssicurazione}} € </span>
            </div> <!-- Assicurazione -->
            <div class="">
              <label class="mb-0  " >Preavviso Tel:</label>
              <span class="mb-0  text-dark" >{{Selected.costoPreavTel}} € </span>
            </div> <!-- Telefonico -->
            <div class="">
              <label class="mb-0  " >T12:</label>
              <span class="mb-0  text-dark" >{{Selected.t12}} € </span>
            </div> <!-- T12 -->
            <div class="">
              <label class="mb-0  " >ConsegnaPiano:</label>
              <span class="mb-0  text-dark" >{{Selected.costoConsegnaPiano}} € </span>
            </div> <!-- ConsegnaPiano -->
            <div class="" *ngIf="Selected.costoContrassegno >0">
              <label class="mb-0  "  >Valore Contrassegno:</label>
              <span class="mb-0  text-dark" >{{Selected.valoreContrassegno}} € </span>
            </div> <!-- ConsegnaPiano -->
          </div>
          <div class="col-lg-4">
            <div class="">
              <label class="mb-0  " >Ritiro:</label>
              <span class="mb-0  text-dark" >{{Selected.costoRitiro}} € </span>
            </div> <!-- Ritiro -->
            <div class="">
              <label class="mb-0  " >Imballaggio:</label>
              <span class="mb-0  text-dark" >{{Selected.costoImballaggio}} € </span>
            </div> <!-- Imballaggio -->
            <div class="">
              <label class="mb-0  " >Varie:</label>
              <span class="mb-0  text-dark" >{{Selected.costoVarie}} € </span>
            </div> <!-- varie -->
            <div class="" *ngIf="Selected.costoAssicurazione >0">
              <label class="mb-0  " >Valore Assicurazione:</label>
              <span class="mb-0  text-dark" >{{Selected.valoreAssicurazione}} € </span>
            </div> <!-- Valore Assicurazione -->
          </div>
        </div>
      </div>
      <div class="card-body" style="height: auto; background-color: #dadff5; margin-top: 20pt;" >
        <div class="d-flex align-items-center justify-content-between">
          <img style="margin: 7pt" alt="Aggiungi" height="60" width="64" src="assets/images/icon/Furgone@4x.png"/>
          &nbsp;
          &nbsp;
          <div class="d-flex  flex-column  align-items-center justify-content-center" style="margin-top: 1.5em;">
            <span class="d-flex justify-content-center align-items-center font-totale" style="margin-top: 5pt;" > TOTALE: &nbsp;&nbsp;&nbsp;<br><span style="font-weight: bold; font-size: 1.4rem;">{{Totale()}} €</span></span>
            <span class="badge badge-pill px-3 font-weight-bold font-14" style="height: 0.05em; margin-left: 0; margin-top: 0;" [ngStyle]="{'background-color': '#53c954'}" > &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
          </div>
          <!--          <label class="mb-0 text-dark" style="font-size: 20px;">TOTALE:</label> &nbsp;&nbsp;-->
          <!--          <span class="mb-0  text-dark" style="font-size: 18px;">{{Totale()}} €</span>-->
          &nbsp;
          <label class="container" style="margin-left: auto; width: auto; margin-right: unset; ">
            <input type="checkbox" [(ngModel)]="Selected.clienteHaPagato" >
            <span class="checkmark"></span>
            PAGATO
          </label>
          <label class="container" style="margin-left: 1em; width: auto; ">
            <input type="checkbox" [(ngModel)]="Selected.fattura" >
            <span class="checkmark"></span>
            FATTURA
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div *ngIf="Selected?.standby || !Selected?.id" class="col-lg-12" >
    <div class="d-flex justify-content-start align-items-center">
      <span class="badge font-20">
        Spedizione N: {{Selected.progressivo}} &nbsp; {{ Selected.id ? '(':''}} {{Selected.id ? (Selected.data_inizio_prevista | date: 'dd/MM/yyyy') : '' }}  {{ Selected.id ? ')':''}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <label class="container" style="margin-left: unset; width: auto; margin-block: auto; margin-right: unset;" (click)="setNazionale(false || Selected.internazionale)">
        <input type="checkbox" [ngModel]="Selected.internazionale" [disabled]="true" >
        <span class="checkmark"></span>
        Internazionale
      </label>
      <label class="container" style="margin-left: unset; margin-block: auto; width: auto; " (click)="setNazionale((true && Selected.internazionale) || Selected.internazionale == undefined)">
        <input type="checkbox" [ngModel]="Selected.internazionale == false"  [disabled]="true"  >
        <span class="checkmark"></span>
        Nazionale
      </label>
    </div>
  </div> <!--sped -->
  <div class="col-12" *ngIf="Selected.internazionale != undefined">
    <div class="row">
      <div *ngIf="(Selected?.standby || !Selected?.id)" class="col-lg-6">
        <div class="card">
          <div class="card-body" >
            <h5 class="card-title" style="margin-left: 10pt">
              <img alt="Aggiungi" style="position: absolute;" height="44" width="39" src="assets/images/icon/Mittente@4x.png"/>
              &nbsp;
              <span style="margin-left: 27pt;">
            MITTENTE
          </span>
              &nbsp;
            </h5>
            <div class="row">
              <div class="col-lg-12 " style="margin-top: -3rem">
                <div class="d-flex justify-content-end">
                  <button type="submit" (click)="verificaIndirizzo(Selected?.mittente?.indirizzo ,Selected?.mittente?.cap ,Selected?.mittente?.citta ,Selected?.mittente?.provincia )" class=" btn waves-effect waves-light">
                    <i-feather name="map" class="feather "></i-feather>
                    <span class="ml-1 font-weight-bold"> MAPPA </span>
                  </button>
                </div>
              </div>
              <div class="col-lg-12 "  *ngIf="permission.isPermitted('scelta-mittente')" >
                <ng-multiselect-dropdown style="margin-left: 40pt;" [settings]="clientedropdownSettings"   [placeholder]="'Cliente'" name="clienti" [data]="clienti"
                                         (onFilterChange)="filtroCliente($event)" (onSelect)="clienteSelezionato($event)" >
                </ng-multiselect-dropdown>
              </div>
              <div class="col-12 form-group mt-3">
                <input type="text" required #nominativo="ngModel" placeholder="COGNOME NOME"  [(ngModel)]="Selected.mittente.nome" name="nome" class="form-control">
                <small class="form-text text-danger" *ngIf="!nominativo.valid && (nominativo.dirty || nominativo.touched)">Nominativo richiesto</small>
              </div>
              <div class="col-12 form-group">
                <input type="text" required #indirizzo="ngModel"  placeholder="INDIRIZZO" [(ngModel)]="Selected.mittente.indirizzo" name="indirizzo" class="form-control">
                <small class="form-text text-danger" *ngIf="!indirizzo.valid && (indirizzo.dirty || indirizzo.touched)">Indirizzo richiesto</small>
              </div>
              <div class="col-3 form-group" style="padding-right: 0rem">
                <input type="text" required #cap="ngModel" placeholder="CAP"  [(ngModel)]="Selected.mittente.cap" name="cap" class="form-control">
                <small class="form-text text-danger" *ngIf="!cap.valid && (cap.dirty || cap.touched)">cap richiesto</small>
              </div>
              <div class="col-6 form-group" style="padding-inline: 0.3rem; ">
                <input type="text" required #citta="ngModel" placeholder="CITTA"  [(ngModel)]="Selected.mittente.citta" name="citta" class="form-control">
                <small class="form-text text-danger" *ngIf="!citta.valid && (citta.dirty || citta.touched)">citta richiesta</small>
              </div>
              <div class="col-3 form-group" style="padding-left: 0rem; ">
                <input type="text" required #provincia="ngModel"  placeholder="PROVINCIA" [(ngModel)]="Selected.mittente.provincia" name="provincia" class="form-control">
                <small class="form-text text-danger" *ngIf="!provincia.valid && (provincia.dirty || provincia.touched)">provincia richiesta</small>
              </div>
              <div class="col-9 form-group"></div>
              <div class="col-3 form-group">
                <ng-multiselect-dropdown [settings]="nazioniDropdownSettings" [placeholder]="'Nazione'" [data]="nazioni" [(ngModel)]="Selected.mittente.nazione">
                </ng-multiselect-dropdown>
                <!--            <small class="form-text text-danger" *ngIf="!Selected.mittente.nazione || !Selected.mittente.nazione[0]">nazione richiesta</small>-->
              </div>
              <div class=" col-4 form-group" style="-ms-flex:0 0 36.5%!important;flex:0 0 36.5%!important;max-width:36.5%!important">
                <input type="text" #cf="ngModel"  placeholder="COD. FISCALE" [(ngModel)]="Selected.mittente.cf" name="cfd" class="form-control">
                <small class="form-text text-danger" *ngIf="!cf.valid && (cf.dirty || cf.touched)">Codice fiscale richiesto</small>
              </div>
              <div class="form-group" style="width: 90px">
                <input type="tel" #telmp="ngModel" pattern="^[0-9-+\s()]*$" [(ngModel)]="Selected.mittente.country" name="telmp" placeholder="PREFISSO" class="form-control">
                <small class="form-text text-danger" *ngIf="!telmp.valid && (telmp.dirty || telmp.touched)">numero non valido</small>
              </div>
              <div class="col-3 form-group">
                <input type="text" #tel="ngModel" placeholder="TELEFONO" [(ngModel)]="Selected.mittente.tel"   name="tel" class="form-control">
                <small class="form-text text-danger" *ngIf="!tel.valid && (tel.dirty || tel.touched)">telefono richiesto</small>
              </div>

            </div>
            <div class=" d-flex  col-lg-2" style="margin-top: 10px">
              <label class="container" style="margin-left: auto; width: auto; margin-right: auto;" *ngIf="!preventivo">
                <input type="checkbox"  [(ngModel)]="Selected.standby" (ngModelChange)="attenderechange()" >
                <span class="checkmark"></span>
                ATTENDERE
              </label>
              <label class="container" style="margin-left: auto; width: auto; ">
                <input type="checkbox"  [(ngModel)]="Selected.ritiro" >
                <span class="checkmark"></span>
                RITIRO
              </label>
              <label class="container" style="margin-left: auto; width: auto; ">
                <input type="checkbox" [(ngModel)]="Selected.triangolazione" >
                <span class="checkmark"></span>
                TRIANGOLAZIONE
              </label>
              <label class="container" style="margin-left: auto; width: auto; ">
                <input type="checkbox" [(ngModel)]="Selected.pratica" >
                <span class="checkmark"></span>
                PRATICA
              </label>
            </div>
          </div> <!-- checks -->
        </div>
      </div> <!-- Mittente -->
      <div *ngIf="Selected?.standby || !Selected?.id" class="col-lg-6">
        <div class="card">
          <div class="card-body" style="background-color: #3baf4a20;" >
            <h5 class="card-title">
              <img alt="Aggiungi" style="position: absolute;" height="40" width="31" src="assets/images/icon/Destinatario@4x.png"/>
              &nbsp;
              <span style="margin-left: 27pt;">
            DESTINATARIO
          </span>
              &nbsp;
            </h5>
            <div class="row">
              <div class="col-lg-12 " style="margin-top: -3rem">
                <div class="d-flex justify-content-end">
                  <button type="submit" (click)="verificaIndirizzo(Selected?.destinatario?.indirizzo ,Selected?.destinatario?.cap ,Selected?.destinatario?.citta ,Selected?.destinatario?.provincia )" class=" btn waves-effect waves-light">
                    <i-feather name="map" class="feather "></i-feather>
                    <span class="ml-1 font-weight-bold"> MAPPA </span>
                  </button>
                </div>
              </div>
              <div class="col-lg-12 "  >
                <ng-multiselect-dropdown style="margin-left: 40pt;" [settings]="clientedropdownSettings" [placeholder]="'Cliente'" name="clienti" [data]="clienti"
                                         (onFilterChange)="filtroCliente($event)" (onSelect)="destinatarioSelezionato($event)" >
                </ng-multiselect-dropdown>
              </div>
              <div class="col-12 form-group mt-3">
                <input type="text" required #nominativod="ngModel" placeholder="COGNOME NOME"  [(ngModel)]="Selected.destinatario.nome" name="nome" class="form-control">
                <small class="form-text text-danger" *ngIf="!nominativod.valid && (nominativod.dirty || nominativod.touched)">Nominativo richiesto</small>
              </div>
              <div class="col-12 form-group">
                <input type="text" required #indirizzod="ngModel"  placeholder="INDIRIZZO" [(ngModel)]="Selected.destinatario.indirizzo" name="indirizzo" class="form-control">
                <small class="form-text text-danger" *ngIf="!indirizzod.valid && (indirizzod.dirty || indirizzod.touched)">Indirizzo richiesto</small>
              </div>
              <div class="col-3 form-group"  style="padding-right: 0rem">
                <input type="text" required #capd="ngModel" placeholder="CAP"  [(ngModel)]="Selected.destinatario.cap" name="cap" class="form-control">
                <small class="form-text text-danger" *ngIf="!capd.valid && (capd.dirty || capd.touched)">cap richiesto</small>
              </div>
              <div class="col-6 form-group" style="padding-inline: 0.3rem; ">
                <input type="text" required #cittad="ngModel" placeholder="CITTA"  [(ngModel)]="Selected.destinatario.citta" name="citta" class="form-control">
                <small class="form-text text-danger" *ngIf="!cittad.valid && (cittad.dirty || cittad.touched)">citta richiesta</small>
              </div>
              <div class="col-3 form-group" style="padding-left: 0rem; ">
                <input type="text" required #provinciad="ngModel"  placeholder="PROVINCIA" [(ngModel)]="Selected.destinatario.provincia" name="provincia" class="form-control">
                <small class="form-text text-danger" *ngIf="!provinciad.valid && (provinciad.dirty || provinciad.touched)">provincia richiesta</small>
              </div>
              <div class="col-9 form-group"></div>
              <div class="col-3 form-group">
                <ng-multiselect-dropdown [settings]="nazioniDropdownSettings" [placeholder]="'Nazione'" [data]="nazioni" [(ngModel)]="Selected.destinatario.nazione">
                </ng-multiselect-dropdown>
                <!--            <small class="form-text text-danger" *ngIf="!Selected.mittente.nazione || !Selected.mittente.nazione[0]">nazione richiesta</small>-->
              </div>
              <div class="col-4 form-group" style="-ms-flex:0 0 36.5%!important;flex:0 0 36.5%!important;max-width:36.5%!important">
                <input type="text" #cfd="ngModel"  placeholder="COD. FISCALE" [(ngModel)]="Selected.destinatario.cf" name="cfd" class="form-control">
                <small class="form-text text-danger" *ngIf="!cfd.valid && (cfd.dirty || cfd.touched)">Codice fiscale richiesto</small>
              </div>
              <div class="form-group" style="width: 90px">
                <input type="tel" #telmpd="ngModel" pattern="^[0-9-+\s()]*$" [(ngModel)]="Selected.destinatario.country" placeholder="PREFISSO" name="telmp" class="form-control">
                <small class="form-text text-danger" *ngIf="!telmpd.valid && (telmpd.dirty || telmpd.touched)">numero non valido</small>
              </div>
              <div class="col-3 form-group">
                <input type="text" #teld="ngModel" placeholder="TELEFONO" [(ngModel)]="Selected.destinatario.tel"   name="tel" class="form-control">
                <small class="form-text text-danger" *ngIf="!teld.valid && (teld.dirty || teld.touched)">telefono richiesto</small>
              </div>
              <div class="col-3 form-group">
                <input type="text" #emaild="ngModel" placeholder="E-MAIL" [(ngModel)]="Selected.destinatario.email"   name="email" class="form-control">
                <small class="form-text text-danger" *ngIf="!emaild.valid && (emaild.dirty || emaild.touched)">emaild richiesta</small>
              </div>
            </div>
          </div>
        </div>
      </div> <!-- Destinatario -->
      <div *ngIf="Selected?.standby || !Selected?.id" class="col-lg-6">
        <div class="card" >
          <div class="card-body" style="background-color: rgb(244,233,222);">
            <div class="d-flex align-items-center justify-content-center" >

              <span style="font-weight: bold">Busta</span>
              &nbsp;&nbsp;
              <a href="javascript:void(0)" ngbTooltip="Busta" class=" text-dark font-24 font-medium mr-2" [class.text-success]="Selected.tipoCollo == 'busta'" (click)="modificaCollichange('busta')">
                <i class="fas fa-shopping-bag" [class.text-success]="Selected.tipoCollo == 'busta'"></i>
              </a>
              &nbsp;&nbsp;
              &nbsp;
              <span style="font-weight: bold">Pacco</span> &nbsp;&nbsp;
              <a href="javascript:void(0)" ngbTooltip="Pacco" class=" text-dark font-24 font-medium mr-2" [class.text-success]="Selected.tipoCollo == 'pacco'" (click)="modificaCollichange('pacco')">
                <i class="fas fa-box-open" [class.text-success]="Selected.tipoCollo == 'pacco'"></i>
              </a>
              &nbsp;&nbsp; &nbsp;
              <span style="font-weight: bold">Pallet</span>&nbsp;&nbsp;
              <a href="javascript:void(0)" ngbTooltip="Pallet" class=" text-dark font-24 font-medium mr-2" [class.text-success]="Selected.tipoCollo == 'pallet'" (click)="modificaCollichange('pallet')">
                <i class="fas fa-pallet" [class.text-success]="Selected.tipoCollo == 'pallet'"></i>
              </a>
              &nbsp;&nbsp;&nbsp;
            </div>

            <app-colli [myProp]="Selected.colli" [(isModifyDisabled)]=" !modificaColli"></app-colli>


          </div>

        </div>
      </div> <!-- Colli -->
      <div *ngIf="Selected?.standby || !Selected?.id" class="col-lg-6">
        <div class="card" >
          <div class="card-body costi" style="background-color: #f5f5be; height: auto">
            <h5 class="card-title">
              <img alt="Aggiungi" height="34" width="31" src="assets/images/icon/Costi@4x.png"/>
              &nbsp;
              COSTI
              &nbsp;
            </h5>
            <h7 class="d-flex justify-content-end">
              &nbsp;&nbsp;&nbsp; * Tutti i valori di questa sezione si intendono in euro
            </h7>
            <div class="row">
              <div class="col-lg-4">
                <div class="d-flex align-items-center">
                  <label class="mb-0" style="font-weight: bold">Costo Spedizione €:</label>
                  <input type="number" style="background-color: #3baf4a60; font-weight: bold" step="0.01" min="0" class="form-control"  [(ngModel)]="Selected.costoSpedizione" >
                </div> <!-- Costo Spedizione -->
              </div>
              <div class="col-lg-4"></div>
              <div class="col-lg-4"></div>
              <div class="col-lg-3">
                <div >
                  <label class="" style="margin-block: auto" >Contrassegno:</label>
                  <input type="number" step="0.01" min="0" class="form-control"  [(ngModel)]="Selected.costoContrassegno" >
                </div> <!-- Contrassegno -->
                <div >
                  <label class="" style="margin-block: auto">Assicurazione:</label>
                  <input type="number" step="0.01" min="0" class="form-control" [(ngModel)]="Selected.costoAssicurazione"  >
                </div> <!-- Assicurazione -->
                <div >
                  <label class=""style="margin-block: auto" >Ritiro:</label>
                  <input type="number"  step="0.01" min="0" class="form-control" [(ngModel)]="Selected.costoRitiro"  >
                </div> <!-- Ritiro -->


              </div> <!-- sx -->
              <div class="col-lg-3">
                <div >
                  <label class="" style="margin-block: auto">Triangolazione:</label>
                  <input type="number" step="0.01" min="0" class="form-control" [(ngModel)]="Selected.costoTriangolazione"  >
                </div> <!-- Triangolazione -->
                <div >
                  <label class="" style="margin-block: auto">Preavviso tel.:</label>
                  <input type="number" step="0.01" min="0" class="form-control" [(ngModel)]="Selected.costoPreavTel"  >
                </div> <!-- Preavviso tel. -->
                <div >
                  <label class="" style="margin-block: auto">Imballaggio:</label>
                  <input type="number" step="0.01" min="0" class="form-control"  [(ngModel)]="Selected.costoImballaggio" >
                </div> <!-- Imballaggio -->

              </div>
              <div class="col-lg-3">
                <div >
                  <label class="" style="margin-block: auto">T12:</label>
                  <input type="number" step="0.01" min="0" class="form-control" [(ngModel)]="Selected.t12"  >
                </div> <!-- T12 -->
                <div >
                  <label class="" style="margin-block: auto" >T10:</label>
                  <input type="number" step="0.01" min="0" class="form-control" [(ngModel)]="Selected.t10"  >
                </div> <!-- T10 -->
                <div >
                  <label class="" style="margin-block: auto">Varie:</label>
                  <input type="number" step="0.01" min="0" class="form-control" [(ngModel)]="Selected.costoVarie"  >
                </div> <!-- Varie -->
                <div  *ngIf="Selected?.costoVarie > 0">
                  <input type="text" placeholder="Descrizione" class="form-control" style="width: 100%" [(ngModel)]="Selected.varie"  >
                </div> <!-- Descri -->
              </div> <!-- dx -->
              <div class="col-lg-3">
                <div >
                  <label class=""style="margin-block: auto" >Deposito:</label>
                  <input type="number" step="0.01" min="0" class="form-control" [(ngModel)]="Selected.costoDeposito"  >
                </div> <!-- costoDeposito -->
                <div >
                  <label class="" style="margin-block: auto">ConsegnaPiano:</label>
                  <input type="number" step="0.01" min="0" class="form-control"  [(ngModel)]="Selected.costoConsegnaPiano" >
                </div> <!-- Imballaggio -->
                <!--            <div >-->
                <!--              <label class="" style="margin-block: auto">Varie:</label>-->
                <!--              <input type="number" step="0.01" min="0" class="form-control" [(ngModel)]="Selected.costoVarie"  >-->
                <!--            </div> &lt;!&ndash; Varie &ndash;&gt;-->
                <!--            <div  *ngIf="Selected?.costoVarie > 0">-->
                <!--              <input type="text" placeholder="Descrizione" class="form-control" style="width: 100%" [(ngModel)]="Selected.varie"  >-->
                <!--            </div> &lt;!&ndash; Descri &ndash;&gt;-->
              </div> <!-- dx -->
            </div>

            <div class="" *ngIf="Selected.costoContrassegno >0 || Selected.costoAssicurazione > 0" style="background-color: #c4c4c4; margin-inline: -1rem; padding-inline: 1rem;">
              <div class="row">
                <div class="col-lg-4"  *ngIf="Selected.costoContrassegno >0">
                  <div class="">
                    <label class="" >Valore Contrassegno</label>
                    <input type="number" step="0.01" min="0" class="form-control"  [(ngModel)]="Selected.valoreContrassegno" >
                  </div> <!-- Valore Contrassegno -->
                </div>
                <div class="col-lg-4" *ngIf="Selected.costoContrassegno >0">
                  <div class="">
                    <label class="" >Contrass. spettante cliente</label>
                    <input type="number" step="0.01" min="0" class="form-control"  [(ngModel)]="Selected.dareCliente" >
                  </div> <!-- Contrass. spettante cliente -->
                </div>
                <div class="col-lg-4" *ngIf="Selected.costoAssicurazione >0 ">
                  <div class="">
                    <label class="" >Valore Assicurazione</label>
                    <input type="number" step="0.01" min="0" class="form-control"  [(ngModel)]="Selected.valoreAssicurazione" >
                  </div> <!-- Valore Assicurazione -->
                </div>
              </div>

              <!--    <input type="checkbox" style="-webkit-transform: scale(1)" class="check" [disabled]="!permission.isPermitted('pagato')" id="clientePagato" [(ngModel)]="Selected.clientePagato">-->
            </div><!-- valori aggiuntivi -->
          </div>
          <div class="card-body" style="height: auto; background-color: #dadff5; margin-top: 20pt;" >
            <div class="d-flex align-items-center justify-content-between">
              <img style="margin: 7pt" alt="Aggiungi" height="60" width="64" src="assets/images/icon/Furgone@4x.png"/>
              &nbsp;
              &nbsp;
              <div class="d-flex  flex-column  align-items-center justify-content-center" style="margin-top: 1.5em;">
                <span class="d-flex justify-content-center align-items-center font-totale" style="margin-top: 5pt;" > TOTALE: &nbsp;&nbsp;&nbsp;<span style="font-weight: bold; font-size: 1.4rem;">{{Totale()|number: "1.2-2"}} €</span></span>
                <span class="badge badge-pill px-3 font-weight-bold font-14" style="height: 0.05em; margin-left: 0; margin-top: 0;" [ngStyle]="{'background-color': '#53c954'}" > &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
              </div>
              <!--          <label class="mb-0 text-dark" style="font-size: 20px;">TOTALE:</label> &nbsp;&nbsp;-->
              <!--          <span class="mb-0  text-dark" style="font-size: 18px;">{{totale}} €</span>-->
              &nbsp;
              <label class="container" style="margin-left: auto; width: auto; margin-right: unset; ">
                <input type="checkbox" [(ngModel)]="Selected.clienteHaPagato" >
                <span class="checkmark"></span>
                PAGATO
              </label>
              <label class="container" style="margin-left: 1em; width: auto; ">
                <input type="checkbox" [(ngModel)]="Selected.fattura" >
                <span class="checkmark"></span>
                FATTURA
              </label>
            </div>
          </div>

        </div>
      </div> <!-- Costi -->
      <div class="col-lg-6" >
        <div class="card">
          <div class="card-body bottom-card-body" >
            <h5 class="card-title " >
              <img alt="Aggiungi" height="34" width="31" src="assets/images/icon/Note@4x.png"/>
              &nbsp;
              NOTE
              &nbsp;
            </h5>
            <div class="row">
              <div class="form-group col-12">
                <textarea type="text" rows="1" class="form-control" style="font-size: large; " [(ngModel)]="Selected.note"></textarea>
              </div>
              <div class="col-lg-3" *ngIf="Selected.pratica">
                <div class="">
                  <label class="" >Data pratica</label>
                  <input type="date"  class="form-control"  [(ngModel)]="Selected.dataPratica" >
                </div> <!-- Data pratica -->
              </div>
              <div class="col-lg-3" *ngIf="Selected.pratica">
                <div class="">
                  <label class="" >Codice pratica</label>
                  <input type="text"  class="form-control"  [(ngModel)]="Selected.codicePratica" >
                </div> <!-- Codice pratica -->
              </div>
              <div class="col-lg-3" *ngIf="Selected.pratica">
                <div class="">
                  <label class="" >Note pratica</label>
                  <textarea type="date" rows="1" class="form-control"  [(ngModel)]="Selected.notePratica" ></textarea>
                </div> <!-- note pratica -->
              </div>
              <div class="col-lg-3 d-flex align-items-center" *ngIf="Selected.pratica">
                <label class="container" style="margin-left: 0px; width: auto; margin-right: auto; ">
                  <input type="checkbox" [(ngModel)]="Selected.praticaChiusa" >
                  <span class="checkmark"></span>
                  PRATICA CHIUSA
                </label> <!-- chiusa pratica -->
              </div>
            </div>


          </div>
        </div>
      </div> <!-- Note -->
      <div class="col-lg-6">
        <div *ngIf="!Selected.id && !preventivo" class="card" >
          <div class="card-body bottom-card-body" >
            <app-file-uploader [afuConfig]="Base64afuConfig" [HideListaFile]="true" (Base64FilesChange)="OnBase64FilesChange($event)"  (onChange)="onFileChanged()"></app-file-uploader>
          </div>
        </div>
        <div *ngIf="Selected.id && !preventivo" class="card" >
          <div class="card-body bottom-card-body" >
            <app-file-uploader [CanDelete]="canDeleteFiles()" (onChange)="onFileChanged()" ></app-file-uploader>
          </div>
        </div>
      </div> <!-- Allegati -->
      <div *ngIf="(preventivo || (!Selected?.standby && Selected?.id)) && !(Selected?.corrieriObject?.length>0)" class="col-lg-12">
        <div *ngIf="Selected.id || preventivo" class="card" >
          <div class="card-body bottom-card-body" >
            <h5 class="card-title d-flex align-items-center justify-content-start " >
              <img alt="Aggiungi" height="40" width="40" src="assets/images/icon/Corrieri@4x.png"/>
              &nbsp;
              CORRIERI

              <label class="container" *ngIf="permission.HasCapacity(['scelta-corriere-manuale']) && permission.isntOperativeRoles(['BM'])" style="margin-left: 10px; width: auto;">
                <input type="checkbox"  [(ngModel)]="corriereManuale" >
                <span class="checkmark"></span>
                MANUALE
              </label>
            </h5>
            <div class="col-lg-3 " *ngIf="corriereManuale  || permission.isOperativeRoles(['BM'])" >
              <label class="">CORRIERE :</label>
              <ng-multiselect-dropdown [disabled]=" Selected.lavorata || !permission.isPermitted('scelta-corriere')" [settings]="corrieredropdownSettings" [placeholder]="'Corriere'" name="categorie" [data]="corrieri"
                                       [(ngModel)]="Selected.corrieriObject">
              </ng-multiselect-dropdown>
            </div> <!--Corrieri-->
            <div class="table-responsive" *ngIf="!corriereManuale  && permission.isntOperativeRoles(['BM'])">
              <table class="table bg-white table-hover align-middle mb-0 table-fixed"  >
                <thead class="fi "   >
                <tr class="table-head">
                  <th scope="col" > CORRIERE </th>
                  <th scope="col" > SERVIZIO </th>
                  <th scope="col" > DATA DI RITIRO </th>
                  <th scope="col" > <span class="font-weight-bold" >TOTALE</span>  </th>
                  <th scope="col" *ngIf="!preventivo"> NOTE </th>
                  <th scope="col" *ngIf="!preventivo"> LETTERA DI VETTURA</th>
                </tr>
                </thead>
                <tbody class="scrollable tablelist" >
                <tr *ngFor="let item of tariffe " >
                  <td >
                    {{item.corriere}}
                  </td>
                  <td>
                    {{item.label}}
                  </td>
                  <td>
                    <input type="date" class="form-control" [(ngModel)]="item.data" >
<!--                    {{item.data | date: 'dd/MM/yyyy'}}-->
                  </td>
                  <td>
                    <span class="font-weight-bold" > {{item.valore}} </span>
                  </td>
                  <td *ngIf="!preventivo">
                    <input type="text" class="form-control" [(ngModel)]="item.note" >
                  </td>
                  <td *ngIf="!preventivo">
                    <a href="javascript:void(0)" ngbTooltip="Crea lettera di vettura" *ngIf="!preventivo && permission.isPermitted('scelta-corriere')" style="color: #53c954; font-size: 20px" class="link  font-weight-bold"
                       (click)="CreaLdv(Selected.id, item)">
                      &nbsp;&nbsp;&nbsp;&nbsp;Crea
                    </a>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div> <!-- Lista Corrieri -->
      <div *ngIf="!Selected?.standby && Selected?.id && !preventivo " class="col-lg-12">
        <div class="card">
          <div class="bottom-card-body">
            <h5 class="card-title " >
              <img alt="Aggiungi" height="40" width="40" src="assets/images/icon/Info@4x.png"/>
              &nbsp;
              INFO
              &nbsp;
            </h5>
            <div class="row">
              <div class="col-lg-3 " *ngIf="Selected?.corrieriObject?.length>0">
                <label class="">CORRIERE :</label>
                <ng-multiselect-dropdown [disabled]=" Selected.lavorata || !permission.isPermitted('scelta-corriere') || permission.isOperativeRoles(['BM'])" [settings]="corrieredropdownSettings" [placeholder]="'Corriere'" name="categorie" [data]="corrieri"
                                         [(ngModel)]="Selected.corrieriObject">
                </ng-multiselect-dropdown>
              </div> <!--Corrieri-->
              <div *ngIf="permission.isPermitted('gestione-info-costi') && permission.isOperativeRoles(['A'])" class=" d-flex align-items-end col-lg-3 ">
                <div class="input-group">
                  <label class="mt-2">PAGAM. CORRIERE</label>
                  &nbsp;
                  <input type="number" class="form-control" [(ngModel)]="Selected.costoCorriere" (ngModelChange)="costocorrierecamb($event)">
                </div>
                <label class="container" style="margin-left: unset; margin-bottom: 28px; width: auto; margin-right: unset;">
                  <input type="checkbox"  [(ngModel)]="Selected.pagatoCorriere" >
                  <span class="checkmark"></span>
                </label>
              </div><!--pagam corriere-->
              <div *ngIf="permission.isPermitted('gestione-info-costi') && permission.isntOperativeRoles(['A'])" class=" d-flex align-items-end col-lg-3 ">
                <div class="input-group">
                  <label class="mt-2">PAGAM. LAERA</label>
                  &nbsp;
                  <input type="number" [readonly]="permission.isntOperativeRoles(['BM', 'A'])" class="form-control" [(ngModel)]="Selected.costoLaera" (ngModelChange)="costolaeracamb($event)">
                </div>
                <label class="container" *ngIf="permission.isOperativeRoles(['BM'])" style="margin-left: unset; margin-bottom: 28px; width: auto; margin-right: unset;">
                  <input type="checkbox" [readonly]="permission.isntOperativeRoles(['BM'])" [(ngModel)]="Selected.pagatoLaera" >
                  <span class="checkmark"></span>
                </label>
              </div><!--pagam corriere-->
              <div *ngIf="permission.isPermitted('gestione-info-costi')" class=" d-flex align-items-end col-lg-3 ">
                <div class="input-group">
                  <label class="mt-2">MARGINE</label>
                  &nbsp;
                  <input type="number" class="form-control" [readonly]="true" [ngModel]="getMargine()" >
                </div>
                <label class="container" style="margin-left: unset; margin-bottom: 28px; width: auto; margin-right: unset;">
                  <input type="checkbox" [readonly]="permission.isntOperativeRoles(['A'])"  [(ngModel)]="Selected.pagatoAgenzia" >
                  <span class="checkmark"></span>
                </label>
              </div><!--Margine-->
              <div class="col-lg-12">

              </div>
              <div class="col-lg-6 form-group">
                <label class="mb-0">LDV:</label>
                <div class="input-group">
                  <input type="text" [readOnly]="permission.isntOperativeRoles(['BM', 'A'])" #ldv="ngModel"  [(ngModel)]="Selected.ldv" name="ldv" class="form-control">
                  <small class="form-text text-danger" *ngIf="!ldv.valid && (ldv.dirty || ldv.touched) && permission.isPermitted('gestione-info')">ldv richiesta</small>
                  <div class="input-group-append">
                    <div class="input-group-text">
                      <div>
                        <button *ngIf="Selected.link" ngxClipboard [cbContent]="Selected.link" ngbTooltip="Copia Link" type="button" class=" btn " style="color: #3baf4a">
                          <i class="fas fa-link" style="color: #3baf4a"></i>
                        </button>
                        <button *ngIf="Selected.link" ngxClipboard [cbContent]="Selected.ldv" ngbTooltip="Copia Ldv" type="button"  class=" btn " style="color: #3baf4a">
                          <i class="far fa-copy" style="color: #3baf4a"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div><!-- ldv -->
              <div class="col-lg-2 d-flex" style="    margin-top: 1rem;" *ngIf="Selected.codiceRitiro && Selected.ldv">
                <label class="container" style="margin-left: unset;     padding-top: 2px; width: auto; ">
                  COD.RITIRO:&nbsp;{{Selected.codiceRitiro}}<br>DATA RITIRO:&nbsp;{{Selected.dataRitiroFiliale | date: 'dd/MM/yyyy'}}
                </label>
              </div>
              <div class="col-lg-2 d-flex align-items-center " *ngIf="!Selected.codiceRitiro && Selected.ldv && !corriereManuale  && permission.isntOperativeRoles(['BM'])">

                  <div class="input-group">
                    <input type="date" class="form-control" [(ngModel)]="Selected.dataRitiroFiliale" >
                  </div>
                  <br>
                  <button  (click)='CreaRitiro()' type="button" class="btn btn-ciano">
                    <i class="fas fa-plus-circle "></i>
                    <span class="ml-1">Crea Ritiro</span>
                  </button>

              </div>
              <div class=" d-flex align-items-end col-lg-4">
                <label class="container" style="margin-left: unset;     padding-top: 2px; width: auto; ">
                  <input type="checkbox" [disabled]="!permission.isPermitted('spedisci')" [(ngModel)]="Selected.spedita" >
                  <span class="checkmark"></span>
                  SPEDITA
                </label>
                <label class="container" style="margin-left: unset;     padding-top: 2px; width: auto; ">
                  <input type="checkbox" [disabled]="!permission.isPermitted('spedisci')" [(ngModel)]="Selected.clientePagato" >
                  <span class="checkmark"></span>
                  PAGATO CONTRASS. SPETTANTE CLIENTE
                </label>
              </div>
              <div class="col-md-6 mt-2" *ngIf="permission.isPermitted('invio-sms')">
                <div class="card">
                  <div class="bottom-card-body" style="background-color: rgba(221, 221, 222, 0.45); height: 40px">
                    <div class="d-flex justify-content-between align-items-center">
                      <i-feather name="send" class="feather-lg"></i-feather>
                      <label class="container" style="      padding-top: 2px;  margin: auto; width: auto;">
                        <input type="checkbox"  [(ngModel)]="Selected.smsM" style="padding-top: 0" >
                        <span class="checkmark"></span>
                        SMS MITTENTE
                      </label>
                      <label class="container" style="      padding-top: 2px;  margin: auto; width: auto; ">
                        <input type="checkbox" [(ngModel)]="Selected.smsD" >
                        <span class="checkmark"></span>
                        SMS DESTINATARIO
                      </label>
                      <label class="container" style="      padding-top: 2px;  margin: auto; width: auto;">
                        <input type="checkbox"  [(ngModel)]="Selected.email" style="padding-top: 0" >
                        <span class="checkmark"></span>
                        EMAIL DESTINATARIO
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> <!-- Allegati -->
      </div> <!-- INFO -->
    </div>
  </div>

</div>
  <aside class="customizer" style="background-color: #3baf4a; " *ngIf="!preventivo">
    <div style="position: absolute; bottom: -2em; left: -20em; ">
      <div class="card" style="background-color: #3baf4a; ">
        <div class="card-body" style="background-color: #3baf4a; ">
          <div class="d-md-flex align-items-center justify-content-end">
            <button type="submit" (click)="saveClick()" class="ml-auto btn p-2 waves-effect waves-light text-light">
              <i-feather name="save" class="feather text-light"></i-feather>
              <span class="ml-1 text-light " style="color:#f8f9fa!important"> SALVA </span>
            </button>
            <button type="submit" *ngIf="Selected.id" (click)="Print()" class="ml-auto btn p-2 waves-effect waves-light text-light">
              <i-feather name="printer" class="feather text-light"></i-feather>
              <span class="ml-1 text-light" style="color:#f8f9fa!important"> STAMPA </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </aside>
<aside class="customizer" style="background-color: #3baf4a; " *ngIf="preventivo">
  <div style="position: absolute; bottom: -2em; left: -20em; ">
    <div class="card" style="background-color: #3baf4a; ">
      <div class="card-body" style="background-color: #3baf4a; ">
        <div class="d-md-flex align-items-center justify-content-end">
          <button type="submit" (click)="CalcolaTariffePreventivo()" class="ml-auto btn p-2 waves-effect waves-light text-light">
            <i-feather name="save" class="feather text-light"></i-feather>
            <span class="ml-1 text-light " style="color:#f8f9fa!important"> Calcola Tariffe </span>
          </button>
          <button type="submit" (click)="PrintPreventivo()" class="ml-auto btn p-2 waves-effect waves-light text-light">
            <i-feather name="printer" class="feather text-light"></i-feather>
            <span class="ml-1 text-light" style="color:#f8f9fa!important"> STAMPA </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</aside>
<ngx-spinner size="medium" [type]="typeSelected"></ngx-spinner>

<br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
<script >
  document.addEventListener("wheel", function(event){
    if(document.activeElement.type === "number"){
      document.activeElement.blur();
    }
  });
</script>
